import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import lotteryService from '../../services/lottery';

const initialState = {
  loading: false,
  lotteries: [],
  error: '',
  params: {
    page: 1,
    perPage: 15,
  },
  meta: {},
};

export const fetchLotteries = createAsyncThunk(
  'lottery/fetchLotteries',
  (params = {}) => {
    const { page, perPage, ...rest } = params;
    const query = {
      page: page ?? initialState.params.page,
      per_page: perPage ?? initialState.params.perPage,
      ...rest,
    };
    return lotteryService.getAll(query).then((res) => res);
  },
);

const lotterySlice = createSlice({
  name: 'lottery',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchLotteries.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchLotteries.fulfilled, (state, action) => {
      const { payload } = action;
      state.loading = false;
      state.lotteries = payload.data;
      state.meta = payload.meta;
      state.params.page = payload.meta.current_page;
      state.params.perPage = payload.meta.per_page;
      state.error = '';
    });
    builder.addCase(fetchLotteries.rejected, (state, action) => {
      state.loading = false;
      state.lotteries = [];
      state.error = action.error.message;
    });
  },
});

export default lotterySlice.reducer;
